import React from 'react';
import { observer } from 'mobx-react';

import Styled from 'styled';
import IconBoxView from 'four-nets/ui/icon-box/icon-box-view';

import defaultStyles from './clickable-icon-box-view.scss';

@Styled(defaultStyles)
@observer
class ClickableIconBoxView extends React.Component {
    static defaultProps = {
        hoverable: true,
    };

    render() {
        const { props } = this;
        const { children, hoverable } = props;
        return (
            <IconBoxView {...props} hoverable={hoverable}>
                {children}
            </IconBoxView>
        );
    }
}

export default ClickableIconBoxView;
